import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, IconButton } from '@mui/material';
import CheckBoxOutlineBlankSharpIcon from '@mui/icons-material/CheckBoxOutlineBlankSharp';
import CheckBoxSharpIcon from '@mui/icons-material/CheckBoxSharp';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSyncToCalendarProvider } from '../../providers/SyncToCalendarProvider';
import Loader from '../Loader/Loader';
import './SyncDialogModal.scss';
import { useProfile } from '../../providers/Profile';
import { removeSpace } from '../SettingsSyncToCal/SettingsSyncToCalHelper';
import { sanitizeHtml } from '../../helpers/sanitizeHtml';

// const emailsNotSupported = ['@aircanada.ca'];

const SyncDialogModal = ({ data, open, onClose }) => {
    const syncToCalendarContext = useSyncToCalendarProvider();
    const [syncModal, setSyncModals] = useState({ instructionModal: false, appleSpecificModal: false, consentModal: false });
    const [emailFormatError, setiOSEmailFormatError] = useState(false);
    const [emailUnsupported, setEmailUnsupported] = useState(false);
    const { t } = useTranslation();
    const profileContext = useProfile();
    const profileData = profileContext?.profile?.results;
    const [hrefData, setHrefData] = useState("");

    useEffect(() => {
        if (!data) return;
        setModalFlags(data);
        setHrefData(`mailto:myaccess@aircanada.ca?&subject=iOS Authorization failure&body=Hello Team,%20%0D%0AName is ${profileData?.['name']}, Emp id is ${profileData?.EmployeeId}, Base Location is ${profileData?.baseLocation} and Equipment is ${profileData?.equipment}`);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const setModalFlags = (data) => {
        if (data.title === t('myBlockMonth.syncToCalendar.myACcessConsent')) {
            setSyncModals({ instructionModal: false, appleSpecificModal: false, consentModal: true })
        } else if (data.title === t('myBlockMonth.syncToCalendar.syncToIOS') && !data.modalInstruction) {
            setSyncModals({ instructionModal: false, appleSpecificModal: true, consentModal: false })
        }
        else if (data.title === t('myBlockMonth.syncToCalendar.syncToIOS') && data.modalInstruction) {
            setSyncModals({ instructionModal: true, appleSpecificModal: false, consentModal: false })
        }
    }

    const createDecsription = () => {
        if (!data.modalFlag.googleFlag && !data.modalFlag.iOSFlag && !data.modalFlag.outlookFlag) return;
        if (data.modalFlag.iOSFlag)
            return { __html: sanitizeHtml(data.descriptioniOS) };
        else if (data.modalFlag.googleFlag)
            return { __html: sanitizeHtml(data.descriptionGoogle) };
        else
            return { __html: sanitizeHtml(data.descriptionOutlook) };
    };

    const handleDialogClose = (event, reason) => {
        reason !== 'backdropClick' && onClose();
    }

    const handleEmailValidation = (e) => {
        // const emailId = e.target.value;
        setEmailUnsupported(false);
        setiOSEmailFormatError((!e.target.value.includes('@')) && data?.emailId?.length !== 0);
        // if(emailsNotSupported.some(extension => emailId.includes(extension))){
        //     setEmailUnsupported(true);
        // }
    }

    return syncToCalendarContext.validateiOSEmailLoading ? <Loader /> : (
        <Dialog
            open={open}
            onClose={handleDialogClose}
            className='sync-modal-dialog'
            maxWidth='lg'
            disableEscapeKeyDown={true}
        >
            <div className='sync-cal__dialog-header'>
                <IconButton
                    aria-label='close'
                    onClick={() => data.handleAction()}
                    className='sync-cal__dialog-close-btn'
                    size="large">
                    <CloseIcon fontSize='large' />
                </IconButton>
            </div>

            <DialogTitle>
                {(data?.emailErrorMsg?.invalidError || data?.pwdErrorMsg) && (
                    <div className='sync-validate-ios__error-notification'>
                        <i className='icon-Error-warning' />
                        <p className='sync-validate-ios__system-error' title="myaccess@aircanada.ca"> {t('myBlockMonth.syncToCalendar.invalidCrends')}&nbsp;
                            <span className='sync-validate-ios__system-error-content'>
                                <a className='sync-validate-ios__system-error-content' href={hrefData}>{t('myBlockMonth.supportTeamLink')}</a>
                            </span>
                        </p>
                    </div>)
                }
                <div>
                    <h2 className="title">{data.title}</h2>
                    {syncModal.instructionModal ? <p className='title-sub'>{data.titleSub}</p>
                        : syncModal.appleSpecificModal ?
                            <div className='description-cntr__apple-specific-modal'>
                                <span className="description__apple-specific-modal" dangerouslySetInnerHTML={{ __html: sanitizeHtml(data.description) }} />
                                <span className="description__sub-apple-specific-modal" dangerouslySetInnerHTML={{ __html: sanitizeHtml(data.descriptionSub) }} />
                            </div>
                            : ''}
                </div>
            </DialogTitle>

            <DialogContent className='dialog-content'>
                {syncModal.consentModal ?
                    <>
                        <p className="description" dangerouslySetInnerHTML={createDecsription()} />
                        <FormControlLabel
                            control={
                                <Checkbox className='styledCheckBox' checked={data.checked} onChange={() => data.handleCheck()}
                                    icon={<CheckBoxOutlineBlankSharpIcon className='check-box-icon-outline' />}
                                    checkedIcon={<CheckBoxSharpIcon className='check-box-con-solid' />} disableRipple name='syncToConsent-checkbox' />
                            }
                            label={t('myBlockMonth.syncToCalendar.understandAndAgree')}
                        />
                    </>
                    : ''
                }

                {syncModal.appleSpecificModal ?
                    <>
                        <div className='sync-apple-specific-modal__input-cntr'>
                            <input type="text" placeholder={t('myBlockMonth.syncToCalendar.syncToIOSId')}
                                className={data?.emailErrorMsg?.alreadyExistsError || emailFormatError || emailUnsupported ?
                                    'sync-apple-specific-modal__input-text sync-apple-specific-modal__input-text-error' : 'sync-apple-specific-modal__input-text'}
                                onChange={(e) => data.setEmailId(e.target.value)} onBlur={(e) => handleEmailValidation(e)} value={data?.emailId} disabled={data?.disableEmailInp} />
                            <div id="sync-apple-specific-modal__text-error" style={{ marginLeft: data?.emailErrorMsg?.alreadyExistsError ? '-4.5rem' : (emailUnsupported ? '1.5rem' : '-17.5rem') }} className="sync-apple-specific-modal__text-error">
                                {data?.emailErrorMsg?.alreadyExistsError && <><i className='icon-circle-flight' /><span style={{ width: '' }}>{t('myBlockMonth.syncToCalendar.iOSAlreadyExistEmail')}</span></>}
                                {emailFormatError && <><i className='icon-circle-flight' /><span style={{ width: '25.5rem' }}>{t('myBlockMonth.syncToCalendar.iOSFormatError')}</span></>}
                                {emailUnsupported && <><i className='icon-circle-flight' /><span style={{ width: '45rem' }}>{t('myBlockMonth.syncToCalendar.airCanadaEmailNotSupported')}</span></>}
                            </div>

                            <input type="text" placeholder={t('myBlockMonth.syncToCalendar.syncToIOSPassword')}
                                className='sync-apple-specific-modal__input-text sync-apple-specific-modal__password'
                                onChange={(e) => data.setAppleSpecificPassword(removeSpace(e.target.value))} value={data?.appleSpecificPassword} />
                        </div>
                    </>
                    : ''
                }
                {syncModal.instructionModal ?
                    <>
                        <div className='dialog-content-main'>
                            <span className='dialog-content-num'>{1}</span>
                            <span className='dialog-content-text'>{t('myBlockMonth.syncToCalendar.syncToiOSCalendarInstr0')}</span>
                        </div>
                        <div className='dialog-content-main dialog-content-margin'>
                            <span className='dialog-content-num'>{2}</span>
                            <span className='dialog-content-text' style={{ width: '60.6rem' }}>{t('myBlockMonth.syncToCalendar.syncToiOSCalendarInstr1')}</span>
                        </div>
                        <div className='dialog-content-main dialog-content-margin'>
                            <span className='dialog-content-num'>{3}</span>
                            <span className='dialog-content-text'>{t('myBlockMonth.syncToCalendar.syncToiOSCalendarInstr2')}<b>{t('myBlockMonth.syncToCalendar.AppSpecificPwd')}</b></span>
                        </div>
                        <div className='dialog-content-main dialog-content-margin'>
                            <span className='dialog-content-num'>{4}</span>
                            <span className='dialog-content-text'>{t('myBlockMonth.syncToCalendar.syncToiOSCalendarInstr3')}&nbsp;<b>{t('myBlockMonth.syncToCalendar.myACcess')}</b></span>
                        </div>
                        <div className='dialog-content-main dialog-content-margin'>
                            <span className='dialog-content-num'>{5}</span>
                            <span className='dialog-content-text'>{t('myBlockMonth.syncToCalendar.syncToiOSCalendarInstr4')}</span>
                        </div>
                        <div className='dialog-content-main dialog-content-margin'>
                            <span className='dialog-content-num'>{6}</span>
                            <span className='dialog-content-text'>{t('myBlockMonth.syncToCalendar.syncToiOSCalendarInstr5')}</span>
                        </div>
                    </>
                    : ''
                }
            </DialogContent>

            <DialogActions>
                <div className="buttons">
                    {(data.handleAction || data.actionLabel) && <Button className='btn-white' onClick={() => data.handleAction()}><span>{data.actionLabel}</span></Button>}
                    {data.handleSecondaryAction &&
                        <Button disabled={(syncModal.consentModal && !data.checked) ||
                            (syncModal.appleSpecificModal && (data.emailId.length === 0 || data.appleSpecificPassword.length === 0 || data?.emailErrorMsg?.alreadyExistsError || emailFormatError || emailUnsupported))}
                            className='btn-black' onClick={() => data.handleSecondaryAction()}>​​​ <span>{data.secondaryActionLabel}</span>
                        </Button>}
                </div>
            </DialogActions>
        </Dialog>
    );
};

export default SyncDialogModal;
